export const getStrategyProfit = value => {
  if (typeof value === 'number') {
    const profit = value
      .toFixed(0)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, '’');

    if (value < 0) return profit.replace('-', '-');

    return `+${profit}`;
  }

  return value;
};
